import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";
import { uploadFile } from "@/lib/adminApi";

export const UploadButton = ({ onUploaded, accept = "image/*", label = "Upload", testId }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const { url, filename } = await uploadFile(file);
      onUploaded(url, filename);
      toast.success("Uploaded");
    } catch (err) { toast.error(err.message); }
    finally { setBusy(false); }
  };

  return (
    <>
      <input ref={ref} type="file" accept={accept} onChange={handle} className="hidden" data-testid={`${testId}-input`} />
      <button type="button" onClick={() => ref.current.click()} disabled={busy} className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm bg-[var(--accent-violet)]/15 text-[var(--accent-violet-light)] hover:bg-[var(--accent-violet)]/25 transition-colors disabled:opacity-60" data-testid={testId}>
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} {busy ? "Uploading..." : label}
      </button>
    </>
  );
};

export const ImageField = ({ value, onChange, testId }) => (
  <div className="flex items-center gap-3">
    {value ? (
      <div className="relative w-28 aspect-video rounded-lg overflow-hidden border border-[rgba(124,58,237,0.2)] flex-shrink-0">
        <img src={value} alt="" className="w-full h-full object-cover" data-testid={`${testId}-preview`} />
        <button type="button" onClick={() => onChange("")} className="absolute top-1 right-1 bg-black/60 rounded-full p-0.5 text-white" data-testid={`${testId}-remove`}><X className="w-3 h-3" /></button>
      </div>
    ) : (
      <div className="w-28 aspect-video rounded-lg border border-dashed border-[rgba(124,58,237,0.25)] flex items-center justify-center text-[10px] text-[var(--text-secondary)] flex-shrink-0">No image</div>
    )}
    <UploadButton onUploaded={(url) => onChange(url)} testId={`${testId}-upload`} label={value ? "Replace" : "Upload image"} />
  </div>
);
